import AppHeader from 'components/AppHeader'
import AppFooter from 'components/AppFooter'
import AppPost from 'components/AppPost'
import AppPublicities from 'components/AppPublicities'

import ShareButtons from 'components/ShareButtons'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Slick from 'vue-slick'

import ModalVideo from 'components/ModalVideo'

import Loading from 'components/Loading'
import PulseLoader from 'vue-spinner/src/PulseLoader'
import ClipLoader from 'vue-spinner/src/ClipLoader'
import SyncLoader from 'vue-spinner/src/SyncLoader'

export default function registerComponents (Vue) {
  Vue.component('app-header', AppHeader)
  Vue.component('app-footer', AppFooter)
  Vue.component('app-post', AppPost)
  Vue.component('app-publicities', AppPublicities)

  Vue.component('share-buttons', ShareButtons)

  Vue.component('modal-video', ModalVideo)

  Vue.component('swiper', swiper)
  Vue.component('swiper-slide', swiperSlide)
  Vue.component('slick', Slick)

  Vue.component('loading', Loading)
  Vue.component('pulse-loader', PulseLoader)
  Vue.component('clip-loader', ClipLoader)
  Vue.component('sync-loader', SyncLoader)
}



// WEBPACK FOOTER //
// ./src/app/config/registerComponents.js